// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];

// Only the legacy compatibility check uses these. Everywhere else the page type
// comes from getCanonicalPageType(), whose vocabulary is the site's own.
export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};

// FAB_EXPAND_DENYLIST is a denylist, not an allowlist — see .claude/context/fab.md
// "Why the auto-expand list is a denylist" for why.
export const FAB_EXPAND_DENYLIST = [
  'cart',
  'checkout',
  'checkout: opc',
];

// Page types where the page is still settling when the assistant mounts, so the
// expand waits longer.
export const EXTENDED_DELAY_PAGE_TYPES = [
  'pip',
  'bip',
  'ppip',
  'plp',
  'category',
  'search results',
];

export const OPEN_TYPES = {
  FAB_OPEN: 'FAB_OPEN',
  FAB_CLOSE: 'FAB_CLOSE',
  DEFAULT_MINIMIZED: 'DEFAULT_MINIMIZED',
  DEFAULT_OPEN: 'DEFAULT_OPEN',
  QUESTION_OPEN: 'QUESTION_OPEN',
  UNKNOWN: 'unknown'
};

export const MAGIC_APRON_CONTAINER_ID = 'DEF_MagicApronLoader';
export const MAGIC_APRON_ASSISTANT_ORIGIN = 'maa';

// External entry-point contract, on the replaying lifeCycle bus. Documented in the README; see
// .claude/context/event-bus.md "Header entry point" for the absolute-state rationale.
// Entry point -> loader. { drawerState, origin? }; origin defaults to ORIGIN_HEADER.
export const UPDATE_DRAWER_STATE = 'magic-apron-assistant.update-drawer-state';

// Loader -> external entry point. { available, drawerState }. `available` is the eligibility of
// the header's entry points (the desktop pill and the bottom nav), not of entry points in general.
export const HEADER_ENTRY_STATUS_EVENT = 'magic-apron-assistant.header-entry-status';

// header-footer-static -> loader. { visible }: its bottom nav is on screen with our entry in it.
export const BOTTOM_NAV_VISIBILITY = 'header.bottom-nav-visibility';

export const EXTERNAL_ENTRY = {
  // An entry-point click reports as submit-click:
  // maa:<entry location>:<page type>:prepopulated:ask magic apron <open|close> click
  SUBMIT_EVENT: 'magic-apron-assistant.submit-click',
  // The entry location of a click that names no origin. Kept apart from ORIGIN_HEADER so a
  // routing rename can't rewrite a reported string.
  DEFAULT_ENTRY_LOCATION: 'header',
  MESSAGE_ORIGIN: 'prepopulated',
  // Open and close are reported separately so analytics can count each interaction.
  OPEN_LABEL: 'ask magic apron open click',
  CLOSE_LABEL: 'ask magic apron close click',
  // A tap on an entry point this page withholds, which shows it disabled. Nothing opens.
  DISABLED_OPEN_LABEL: 'ask magic apron open click:disabled',
  ORIGIN_HEADER: 'header',
  ORIGIN_FAB: 'fab',
  ORIGIN_BOTTOM_NAV: 'bottom-nav',
};
